<template>
    <div>
        <CardBase>
            <MacroSubHeader
                title="Banners"
                icon="el-icon-picture-outline"
            >
                <template slot="actions">
                    <el-button
                        size="small" 
                        type="primary"
                        @click="openModal"
                    >
                        <i class="fa fa-plus"></i>
                        Adicionar
                    </el-button>
                </template>
            </MacroSubHeader>

            <CardBase>
                <BannerList ref="bannerList"/>
            </CardBase>
        </CardBase>

        <!-- BannerCreate -->
        <BannerCreateModal ref="bannerCreateModal" @created="handleDispatch"/>
    </div>
</template>
<script>    
    //Components
    import MacroSubHeader from "@/components/_macro/MacroSubHeader.vue";
    import CardBase from "@/components/_macro/CardBase.vue";

    import BannerList from '@/components/_macro/banner/BannerList.vue';
    import BannerCreateModal from "@/components/_macro/banner/BannerCreateModal.vue";

    export default {
        name: "banners",
        data() {
            return {}
        },
        methods: {
            openModal() {
                this.$refs.bannerCreateModal.toggleModal();
            },
            async handleDispatch() {
                await this.$refs.bannerList.fetch();
            },
        },
        components: {
            CardBase,
            MacroSubHeader,
            BannerList,
            BannerCreateModal,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_internal/configuracoes/banner/Index.vue